
// 订单确认页面——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `page/orderConfirmation/index${i + 1}`,
  name: `page/orderConfirmationIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/orderConfirmation/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 订单确认页面——主流程，开始
    ...MainRoutes
  ]
}
